export default {
    DEFAULT: 'default',
    MINIMAL: 'minimal',
    HIDDEN: 'hidden',
};
